/**
 * @param {jQuery} $
 * @param {AppConfig} config
 * @param {AppLibrary} library
 * @constructor
 */
export let TabStats = function ($, config, library) {
  /**
   * @type {string}
   */
  let template = `
<div class="slp-tab-grid">
 <div class="slp-tab-grid-row">
      <div class="slp-tab-grid-col slp-strong">
           ` + config.getPopupText().earningPoints + `
      </div>
      <div class="slp-tab-grid-col slp-strong text-center">
         ` + config.getPopupText().numberPoints + `
       </div>  
 </div>
    {{#rewards}}
        <div class="slp-tab-grid-row">
            <div class="slp-tab-grid-col">
                 {{name}}
            </div>
            <div class="slp-tab-grid-col text-center">
                 {{&value}}
            </div>
        </div>
    {{/rewards}}
    {{^rewards}}
        <div class="slp-tab-grid-row">
            <div class="slp-tab-grid-col slp-wide text-center">
                ` + config.getPopupText().didntEarnPoint + `
            </div>
        </div>
    {{/rewards}}
    <div class="slp-tab-grid-row border-none">
        <div class="slp-tab-grid-col">&nbsp;</div>
        <div class="slp-tab-grid-col text-center">
            <div>
                <strong>` + config.getPopupText().redeemed + `</strong> 
                {{spent}}
            </div>
            <div style="margin-top:0.939rem;">
                <strong>` + config.getPopupText().available + `</strong> 
                {{balance}}
            </div>
        </div>
    </div>
</div>
`;

  /**
   * @type {{tab: string, heading: string}}
   */
  let texts = config.getTexts().popup_pages.text.history;

  /**
   * @return {string}
   */
  this.getTitle = () => {
    return texts;
  };

  /**
   * @return {string}
   */
  this.getBody = () => {
    let rewardRates = config.getRewardsRates();
    let pointNames = config.getPointNames();
    let customer = config.getCustomer();

    let rewards = [];

    for (let type in customer.rewards) {
      if (!customer.rewards.hasOwnProperty(type) || !rewardRates[type].active) {
        continue;
      }
      if (type === 'manual' || rewardRates[type].amount === 0) {
        continue;
      }
      rewards.push({
        type: type,
        name: config.rewardNames()[type],
        amount: customer.rewards[type]
      });
    }

    return library.mustache().render(
        config.customization().tabStatsTemplate || template,
        {
          header: texts.heading,
          rewards: rewards,
          value: function () {
            return this.amount + ' ' + (this.amount !== 1 ? pointNames.plural : pointNames.singular);
          },
          spent: customer.spent,
          balance: customer.balance,
          singular: pointNames.singular,
          plural: pointNames.plural
        }
    );
  };

  /**
   *
   */
  this.afterDisplay = () => null;
};